export default ({ openC, listData }) => {
    let articleId = '';

    // 打开收藏弹框
    function openCollDialog(row) {
        articleId = row.articleId;
        openC(row);
    }

    // 处理收藏成功
    function handleCollSuccess(favoriteId) {
        const index = listData.value.findIndex(item => item.articleId === articleId);
        if (index > -1) {
            listData.value[index].favoriteId = favoriteId;
        }
    }

    return { openCollDialog, handleCollSuccess }
}